/* eslint-disable no-console */
import OneOnOneLayout from "../layouts/OneOnOneLayout";
import OneOnOneStreamLayout from "../layouts/OneOnOneStreamLayout";

const subrouteName = name => {
	return `ONE_ON_ONE/${ name }`;
};

// eslint-disable-next-line no-unused-vars
export default ( {
	app,
	authService,
	layouts,
	loadedSlices,
} ) => {
	const lazyLoadOneOnOneComponent = ( { component, } ) => {
		return () => {
			if ( !loadedSlices.has( "@teaming/slice-one-on-one" ) ) {
				return import( "@teaming/slice-one-on-one" ).then( async ( { oneOnOneSlice, } ) => {
					oneOnOneSlice();
					loadedSlices.set( "@teaming/slice-one-on-one", true );
					return app.component( component );
				} );
			}
			return Promise.resolve( app.component( component ) );
		};
	};

	return [
		{
			path: "/one-on-ones",
			name: "",
			meta: { title: "slice-oneonone.routes.listing", },
			component: layouts.StandardAppLayout,
			props: true,
			children: [
				{
					path: "",
					name: "One on One Listing",
					component: lazyLoadOneOnOneComponent( { component: "OneOnOneListingHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		},

		{
			path: "/one-on-one/:teamId/stream/:docType",
			name: subrouteName( "Stream" ),
			meta: { preventDefaultRouteTitle: true, }, // see DocumentMixin
			component: OneOnOneStreamLayout,
			props: true,
			children: [
				{
					path: "",
					name: "1:1 Stream",
					component: lazyLoadOneOnOneComponent( { component: "OneOnOneStreamHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		},

		{
			path: "/one-on-one/:teamId/goal",
			name: "",
			meta: { preventDefaultRouteTitle: true, }, // see DocumentMixin
			component: layouts.RouterViewLayout,
			props: true,
			children: [
				{
					path: "new",
					name: subrouteName( "NEW_GOAL" ),
					meta: { bodyClass: "teaming-gokr--page", },
					component: lazyLoadOneOnOneComponent( { component: "OneOnOneNewGoalHOC", } ),
					props: true,
				},
				{
					path: ":goalId",
					name: subrouteName( "UPDATE_GOAL" ),
					meta: { bodyClass: "teaming-gokr--page", },
					component: lazyLoadOneOnOneComponent( { component: "OneOnOneGoalHOC", } ),
					props: true,
				},
				{
					path: ":goalId/key-result/new",
					name: subrouteName( "NEW_KEY_RESULT" ),
					meta: { bodyClass: "teaming-gokr--page", },
					component: lazyLoadOneOnOneComponent( { component: "OneOnOneNewKeyResultHOC", } ),
					props: true,
				},
				{
					path: ":goalId/key-result/:keyResultId",
					name: subrouteName( "UPDATE_KEY_RESULT" ),
					meta: { bodyClass: "teaming-gokr--page", },
					component: lazyLoadOneOnOneComponent( { component: "OneOnOneKeyResultHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		},

		{
			path: "/one-on-one/:teamId",
			name: "",
			meta: { preventDefaultRouteTitle: true, }, // see DocumentMixin
			component: OneOnOneLayout,
			props: true,
			children: [
				// redirect
				{
					path: "",
					name: "One on One",
					redirect: to => {
						const hasTrailingSlash = to.path.charAt( to.path.length - 1 ) === "/";
						const toPath = hasTrailingSlash ? to.path : `${ to.path }/`;
						return { path: `${ toPath }stream/shared`, };
					},
				},
				// redirect
				{
					path: "meetings",
					name: subrouteName( "TODAYS_MEETINGS" ),
					redirect: to => {
						const newPath = to.path.substring( 0, to.path.length - 8 ); // eslint-disable-line no-magic-numbers
						return { path: `${ newPath }stream/shared`, };
					},
				},
				// redirect
				{
					path: "meetings/:meetingDate",
					name: subrouteName( "MEETINGS" ),
					redirect: to => {
						const newPath = to.path.split( "/" ).slice( 0, 3 ).join( "/" ); // eslint-disable-line no-magic-numbers
						return { path: `${ newPath }/stream/shared`, };
					},
				},
				{
					path: "timeline",
					name: subrouteName( "TIMELINE" ),
					component: lazyLoadOneOnOneComponent( { component: "OneOnOneTimelineHOC", } ),
					props: true,
				},
				{
					path: "workstyles",
					name: subrouteName( "WORK_STYLES" ),
					component: lazyLoadOneOnOneComponent( { component: "OneOnOneWorkstylesHOC", } ),
					props: true,
				},
				{
					path: "teammate",
					name: subrouteName( "TEAMMATE" ),
					component: lazyLoadOneOnOneComponent( { component: "OneOnOneTeammateHOC", } ),
					props: true,
				},
				{
					path: "commitments",
					name: subrouteName( "ACTION_ITEMS" ),
					component: lazyLoadOneOnOneComponent( { component: "OneOnOneCommitmentsHOC", } ),
					props: true,
				},
				{
					path: "goals",
					name: subrouteName( "GOALS" ),
					component: lazyLoadOneOnOneComponent( { component: "OneOnOneGoalsHOC", } ),
					props: true,
				},
				{
					path: "settings",
					name: subrouteName( "SETTINGS" ),
					component: lazyLoadOneOnOneComponent( { component: "OneOnOneSettingsHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		},
	].filter( r => !!r );
};
